import { render } from "./DescriptionTab.vue?vue&type=template&id=207e4a54&scoped=true"
import script from "./DescriptionTab.vue?vue&type=script&lang=js"
export * from "./DescriptionTab.vue?vue&type=script&lang=js"

import "./DescriptionTab.vue?vue&type=style&index=0&id=207e4a54&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e4a54"]])

export default __exports__